module.exports = __webpack_public_path__ + "media/images/flags/4x3/gnq-1f2b45ca0b4b97edab4ab439cd775cbe.svg";